import React from 'react';
import { Show, SimpleShowLayout, ReferenceField, FunctionField, TextField, DateField } from 'react-admin';

const subsidiaryRenderer = record => `${record.id}: ${record.name}`;

const LimitGroupShow = props => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<ReferenceField
				source="subsidiaryId"
				reference="subsidiaries"
			>
				<FunctionField render={subsidiaryRenderer} />
			</ReferenceField>
			<TextField source="description" />
		</SimpleShowLayout>
	</Show>
);

export default LimitGroupShow;
